import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import { convertStraight, formatDateTime } from "../../common-data/Converts";

const WatiKeywordCountMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="all-followuo-info-container">
                  <div className="lead-multi-value-cols px20px pb20px pt20px">
                    <div className="label-value flex-col">
                      <span className="label">gym name</span>
                      <span className="value">{row?.gym_name || "NA"}</span>
                    </div>

                    <div className="label-value flex-col">
                      <span className="label">keyword</span>
                      <span className="value">{row?.keyword || "NA"}</span>
                    </div>

                    <div className="label-value flex-col">
                      <span className="label">source name</span>
                      <span className="value">
                        {row?.source_name?.replace(/_/g, " ") || "NA"}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">Trial Date</span>
                      <span className="value">
                        {row?.date ? convertStraight(row.date) : ""}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">preferred slot</span>
                      <span className="value">
                        {row?.preferred_slot || "-"}
                      </span>
                    </div>

                    <div className="label-value flex-col">
                      <span className="label">date added</span>
                      <span className="value">
                        {row?.date_added ? formatDateTime(row.date_added) : ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default WatiKeywordCountMobile;
